import { createRouter } from '@tanstack/react-router';
import { routeTree } from '../routeTree.gen';

// Create router with generated route tree
// The route tree is auto-generated by TanStack Router Vite plugin
export const router = createRouter({ 
  routeTree,
});

// Register router types
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

